import { RouteObject } from "react-router-dom";

import ErrorBoundary from "src/components/Errors/ErrorBoundary.tsx";
import { JobsDetailPage } from "src/pages/Jobs/JobsDetailPage.tsx";
import { JobsPage } from "src/pages/Jobs/JobsPage.tsx";

export const jobsRoutes: RouteObject[] = [
  {
    path: "/jobs",
    Component: JobsPage,
    ErrorBoundary: ErrorBoundary,
  },
  {
    path: "/jobs/:jobId",
    Component: JobsDetailPage,
    ErrorBoundary: ErrorBoundary,
  },
];
